/* Parse template email */
import { ContentState, convertFromHTML, convertToRaw } from 'draft-js'
import mustache from 'mustache'

const parseEmail = async (template, constituency, sender = {}) => {
  /* Convert stored email body string to format required by MuiRte component */
  const vars = {
    mp_name: constituency.mp_name,
    num_children: Number(
      constituency?.poverty_stats['number_201920'] ||
        constituency?.poverty_stats['number_201819']
    ).toLocaleString('en-GB'),
    perc_children: Number(
      constituency?.poverty_stats['percentage_201920'] ||
        constituency?.poverty_stats['percentage_201819']
    ).toLocaleString('en-GB', { style: 'percent' }),
    constituency_name: constituency.name,
    sender_first_name: sender.first_name,
    sender_last_name: sender.last_name,
  }

  const contentHTML = convertFromHTML(mustache.render(template, vars))

  const state = ContentState.createFromBlockArray(
    contentHTML.contentBlocks,
    contentHTML.entityMap
  )
  return JSON.stringify(convertToRaw(state))
}

export { parseEmail }
